import { parseCurrency } from '@helper/parseCurrency'

export const parseConciliationFooterBudgetData = (data: any[]): any[] => {
  const res = []
  let realAno = 0
  let comerc = 0
  let orcamLoj = 0
  let ajust = 0
  let margem = 0

  let diasUteisUltimoAno = 0
  let duPrevisaoComercial = 0
  let diasUteisAnoAtual = 0

  data.forEach(obj => {
    return (realAno += obj.vendasUltimoAno)
  })
  data.forEach(obj => {
    return (comerc += obj.previsaoComercial)
  })
  data.forEach(obj => {
    return (orcamLoj += obj.previsaoOperacoes)
  })
  data.forEach(obj => {
    return (ajust += obj.previsao)
  })

  data.forEach(obj => {
    return (margem += obj.margemFinalValor)
  })

  data.forEach(obj => {
    return (diasUteisUltimoAno += obj.diasUteisUltimoAno)
  })

  data.forEach(obj => {
    return (duPrevisaoComercial += obj.duPrevisaoComercial)
  })

  data.forEach(obj => {
    return (diasUteisAnoAtual += obj.diasUteisAnoAtual)
  })

  res.push({
    'orcamento-id': ' ',
    'orcamento-ano': '',
    'orcamento-gp': '',
    'orcamento-gc': '',
    'orcamento-empresa': '',
    'orcamento-categoria': '',
    'orcamento-loja': '',
    'orcamento-fator-venda': '',
    'orcamento-real-ano-anterior': parseCurrency({
      value: realAno,
      country: 'pt-br'
    }),
    'orcamento-comercial': parseCurrency({
      value: comerc,
      country: 'pt-br'
    }),
    'orcamento-alterado-loja': '',
    'orcamento-orçamento-loja': parseCurrency({
      value: orcamLoj,
      country: 'pt-br'
    }),
    'orcamento-alterado-asjutado': '',
    'orcamento-ajustado': parseCurrency({
      value: ajust,
      country: 'pt-br'
    }),
    'orcamento-margem': parseCurrency({
      value: margem,
      country: 'pt-br'
    }),
    'orcamento-margem-perc': parseCurrency({
      value: (margem / ajust) * 100,
      country: 'pt-br'
    }),
    'orcamento-ano-anterior': parseCurrency({
      value: diasUteisUltimoAno,
      country: 'pt-br'
    }),
    'orcamento-du-comercial': parseCurrency({
      value: duPrevisaoComercial,
      country: 'pt-br'
    }),
    'orcamento-du-loja': parseCurrency({
      value: diasUteisAnoAtual,
      country: 'pt-br'
    })
  })

  return res
}
